module.exports = __webpack_public_path__ + "AmanAgnihotri-f95d52f1.webp";